// frontend/src/pages/HomePage.jsx (Code inchangé)

import Hero from '../components/home/Hero';
import Features from '../components/home/Features';
import AssociationStory from '../components/home/AssociationStory';
import CookieConsent from "../components/CookieConsent";
import Stats from '../components/home/Stats'; 
import './../styles/HomePage.css';

// Si tu crées un nouveau composant pour l'adhésion comme discuté
// import MembershipCTA from '../components/home/MembershipCTA'; 

export default function HomePage() {
return (
<div className="homepage">

{/* Le CookieConsent devrait idéalement être en haut ou en dehors du flux principal (fixed) */}
<CookieConsent />

{/* 1. HERO : L'accroche (Contiendra les nouvelles phrases et boutons) */}
<section className="homepage__hero">
<Hero />
</section>

{/* 2. STATS : La preuve immédiate */}
<section className="homepage__stats">
<Stats />
</section>

{/* 3. FEATURES : Tes services & L'IA */}
<section className="homepage__features">
<Features />
</section>

{/* 4. HISTOIRE : La légitimité */}
<section className="homepage__story">
<AssociationStory />
</section>

{/* 5. APPEL À L'ACTION FINAL (Suggestion) */}
{/* <section className="homepage__cta">
 <MembershipCTA /> 
</section> */}

</div>
);
}